module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(is_complete === 0) { 
__p+='\n	<div class="invalid-team-message">\n		<p>\n			Your team is currently invalid and will not score for the next round.\n			Please ensure you complete your team and select your C/VC before lockout\n		</p>\n	</div>\n';
 } 
__p+='';
}
return __p;
};
